<template>
  <div class="understanding-you">
    <ChooseQuestion class="membership-selector container is-fluid" question="I want to join as a"
                    v-bind:options="membershipTypes"
                    :existingValue="selectedType"
                    @question-answered="membershipTypeSelected" ref="memberSelector" :isDropdownControlled="true" />
    <div class="mobile-target">
      <div v-if="isMobile">
        <component v-touch:swipe="swipeHandler" @kill-me="killMe"
                   ref="comp" @hook:mounted="initSections()" v-bind:is="component" v-bind="currentProperties" @confirmClicked="confirm" />
      </div>
      <div v-else>
        <component ref="comp" v-bind:is="component" v-bind="currentProperties" @kill-me="killMe"
                   @onFinalSection="areAllQuestionsShown=$event;" @confirmClicked="confirm" />
      </div>
    </div>
    <NextButton v-if="showNavigateNext" @clicked="navigateNext" />
  </div>
</template>
<script>

import {
  mapActions, mapGetters, mapState, mapMutations,
} from 'vuex';
import ChooseQuestion from '@/components/ChooseQuestion.vue';
import NextButton from '@/components/NextButton.vue';
import Associate from './associate/Associate.vue';
import Fellow from './fellow/Fellow.vue';
import PharmaceuticalScientist from './pharmaceuticalscientist/PharmaceuticalScientist.vue';
import Member from './member/Member.vue';
import PreReg from './prereg/PreReg.vue';
import Student from './student/Student.vue';
import '@/styles/application.scss';
import Mobile from '../mobile/mobile';
import Ga from '../ga';

export default {
  name: 'UnderstandingYou',
  props: {
    backButton: HTMLAnchorElement,
  },
  components: {
    ChooseQuestion,
    Associate,
    Fellow,
    PharmaceuticalScientist,
    Member,
    PreReg,
    Student,
    NextButton,
  },
  created() {
    this.selectedType = this.memberCategory || this.application.Type;
  },
  mounted() {
    if (this.memberCategory) {
      Ga.sendMembershipCategory(this.memberCategory);
    }

    if (this.selectedType) {
      this.component = this.comps.find((c) => c.name === this.selectedType)?.comp;
    }
  },
  computed: {
    ...mapGetters(['membershipTypes', 'isFinalSection', 'getUnderstandingYou']),
    ...mapState(['isMobile', 'application', 'memberCategory']),
    showNavigateNext() {
      return this.component !== '' && this.component !== 'Fellow';
    },
    currentProperties() {
      const c = this.component ? this.component.name : '';

      if (['Student', 'PreReg', 'Member', 'PharmaceuticalScientist', 'Associate'].includes(c)) {
        return c === 'Member' ? {
          dataGetter: () => {
            const data = this.getUnderstandingYou(this.selectedType);
            if (typeof data.wasSubject === 'boolean') {
              data.wasSubject = data.wasSubject ? 'am / have been' : 'have not been';
            }

            return data;
          },
        }
          : {
            dataGetter: () => this.getUnderstandingYou(this.selectedType),
          };
      }

      return {};
    },
  },
  methods: {
    ...mapActions(['saveUnderstandingYouToStore']),
    ...mapMutations(['updateAreasWithOrWithoutInsuranceOption']),
    navigateNext() {
      if (this.isFinalSection) {
        this.confirm();
      } else Mobile.swipeHandler('left', this.$refs.comp);
    },
    confirm() {
      const component = this.$refs.comp;
      const selected = this.selectedType;
      component.$v.$touch();
      if (component.$v.$anyError) {
        component.$nextTick(() => {
          // - 100 is offset because of Sticky positional DNN header.
          window.scrollTo(0, (document.querySelector('.error').getBoundingClientRect().top - 100) + window.pageYOffset);
        });
        return;
      }

      console.log(selected);

      this.saveUnderstandingYouToStore({ understandingYou: component.understandingYou, selectedType: selected });

      window.scroll(0, 20);
      this.$emit('completed');
    },
    initSections() {
      Mobile.initSections(this.$refs.comp.$el);
    },
    swipeHandler(direction) {
      Mobile.swipeHandler(direction, this.$refs.comp);
    },
    membershipTypeSelected(e) {
      if (e.text && this.selectedType !== e.text) {
        this.selectedType = e.text;
        this.updateAreasWithOrWithoutInsuranceOption(this.selectedType);
        if (this.$refs.comp) this.$refs.comp.$destroy();
        this.component = this.comps.find((c) => c.value === e.value + 1).comp;
        // Send to Ga
        Ga.sendMembershipCategory(this.selectedType);
      }
    },
    killMe(comp) {
      if (comp.$options.name === 'Associate' || comp.$options.name === 'PreReg') {
        const member = this.comps[0];
        comp.$destroy();
        this.component = member.comp;
        this.selectedType = member.comp.name;
        this.$refs.memberSelector.selected = 0;
      }
    },
  },
  data() {
    return {
      areAllQuestionsShown: false,
      selectedType: '',
      component: '',
      comps: [
        { value: 1, comp: Member, name: 'Member' },
        { value: 2, comp: Student, name: 'Student' },
        { value: 3, comp: PreReg, name: 'Foundation Trainee' },
        { value: 4, comp: PharmaceuticalScientist, name: 'Pharmaceutical Scientist' },
        { value: 5, comp: Associate, name: 'Associate' },
        { value: 6, comp: Fellow, name: 'Fellow' },
      ],
    };
  },
};
</script>
<style>
  .form-label {
    font-weight: bold;
  }
</style>
